<template>
  <div class="d-block w-100">
    <label class="font-size-12">{{ label ? label: 'Font Family' }}</label>
    <v-select :options="fontFamily" :clearable="false" :searchable="false" v-model="selected">
      <template v-slot:option="option">
        <span :style="{ fontFamily: option.val }">{{ option.label }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { FONT_FAMILY1 } from '@src/constants'
export default {
  components: {
  },
  props: {
    value: { required: false, type: [String], default: '' },
    label: { required: false, type: [String], default: '' }
  },
  data() {
    return {
      fontFamily :FONT_FAMILY1,
    }
  },

  computed: {
    selected: {
      get() {
        let val = "'Poppins',sans-serif"
        if (this.value) val = this.value

        return this.fontFamily.find(item => item.val === val)
      },
      set(newValue) {
        if (newValue)
          this.$emit('input', newValue.val)
          this.$emit('change', newValue.val)
      },
    },
  },
  methods: {
  }
}
</script>
<style lang="scss">
  .vs--single .vs__selected {
    padding-left: 10px;
  }
  .vs__open-indicator {
    scale: 0.6;
  }
</style>